import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export const ExportExcel = (data, fileName = "Export.xlsx") => {
	const worksheet = XLSX.utils.json_to_sheet(data);

	const workbook = XLSX.utils.book_new();

	XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

	const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

	const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

	const link = document.createElement("a");
	link.href = URL.createObjectURL(blob);

	link.download = fileName;
	document.body.appendChild(link);

	link.click();

	document.body.removeChild(link);
};

export const ExportPdf = (data, fileName = "Export.pdf", title = "") => {
	if (!data?.length) return;

	const headers = Object.keys(data[0]);
	const rows = data.map((row) => headers.map((header) => row[header] ?? ""));

	const doc = new jsPDF({
		orientation: "landscape",
	});

	if (title) {
		doc.setFontSize(14);
		doc.text(title, 14, 15);
	}

	autoTable(doc, {
		head: [headers],
		body: rows,
		startY: title ? 20 : 10,
		styles: { fontSize: 8 },
		headStyles: { fillColor: [41, 128, 185] },
	});

	doc.save(fileName);
};
